import axios from "axios";

export default {

    // get historical stage and flow data from USGS API
    getGagesHistory: function(gageID, paramType) {
        const paramID = paramType === 'flow' ? "00060" : "00065";
        const apiURL = 'https://waterservices.usgs.gov/nwis/iv/?format=json'
        const sites = '&sites=' + gageID;
        const DatePeriod = '&period=P4D';
        const typeParams = '&parameterCd=' + paramID;
        const siteStatus = '&siteStatus=all';

        let query = apiURL + sites + DatePeriod + typeParams + siteStatus;
        return axios.get(query);
    },

    //// hit backend route to return data for all gages
    //getAllGages: function () {
    //    return fetch('RoanokeFloodApp/api/gages');
    //},

    //// Function calls to fetch the data from the stored procedures in the database
    //getAllGages: function (gageID) {
    //    return fetch(`RoanokeFloodApp/api/gages/GatAllGagesData/${gageID}`);
    //},

    getGage: function (gageID) {
        return fetch(`RoanokeFloodApp/api/gages/GetGageData/${gageID}`);
    },

    getNOAAObserved: function (gageID, paramType) {
        return fetch(`RoanokeFloodApp/api/gages/GetNOAAObs/${gageID}/${paramType}`);
    },

    getNOAAForecast: function (gageID, paramType) {
        return fetch(`RoanokeFloodApp/api/gages/GetNOAAFore/${gageID}/${paramType}`);
    },

    getUSGSObserved: function (gageID, paramType) {
        return fetch(`RoanokeFloodApp/api/gages/GetUSGSObs/${gageID}/${paramType}`);
    },

    getAllBuildings: function () {
        return fetch(`RoanokeFloodApp/api/gages/GetAllBuildingsData`);
    },

    getImpactedBuildings: function (stageID) {
        return fetch(`RoanokeFloodApp/api/gages/GetBuildingImpacts/${stageID}`);
    },

    getReturnPeriod: function (elevID) {
        return fetch(`RoanokeFloodApp/api/gages/GetReturnPeriods/${elevID}`);
    },
    
    getSingleGage: function (id, paramType) {
        return fetch(`RoanokeFloodApp/api/gages/${id}/${paramType}`);
    },

    // hit backend route to get forecast readings (NOAA) for single gage
    getSingleForecast: function () {
        return fetch('RoanokeFloodApp/api/gages/forecast');
    },

    // TODO add call to NOAA
    getGagesForecast : axios.get('https://water.weather.gov/ahps2/hydrograph_to_xml.php?gage=ronv2&time_zone=est')
};


// WEBPACK FOOTER //
// ./src/utils/api.js